import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../packages/kiti/components/form/NumberInput'

const GeneralSection = () => (
  <Grid paddingGutter={0.5} wrap>
    <Col width="100%" wrapOn="sm">
      <FormItem label="Nome*" field="name" />
    </Col>

    <Col width="100%" wrapOn="sm">
      <FormItem label="Quantidade de QrCodes*" field="qrcodesCount" Input={NumberInput} max={2000} min={0} onlyInt />
    </Col>
  </Grid>
)

export default GeneralSection
